export class PathwayLocalStorageUtil {
  private static readonly CONFETTI_SHOWN_KEY = 'pathway_confetti_shown';

  static getConfettiShownUuids(): string[] {
    try {
      const stored = localStorage.getItem(this.CONFETTI_SHOWN_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  static hasConfettiBeenShown(enrollmentUuid: string): boolean {
    return this.getConfettiShownUuids().includes(enrollmentUuid);
  }

  static markConfettiAsShown(enrollmentUuid: string): void {
    const shown = this.getConfettiShownUuids();
    if (!shown.includes(enrollmentUuid)) {
      shown.push(enrollmentUuid);
      localStorage.setItem(this.CONFETTI_SHOWN_KEY, JSON.stringify(shown));
    }
  }
}
